import type { HelpFile } from '../../types/help'
import { InboundConnectorConfigLayoutTestIds } from '../../../testids/InboundConnectorConfigLayoutTestIds'

export const inboundConnectorConfigLayoutHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [InboundConnectorConfigLayoutTestIds.inboundConfigLayout]:
      'Unter-Navigation für den Konfigurations-Tab — Verbindung, Abgleich oder Operationen wählen.',
    [InboundConnectorConfigLayoutTestIds.inboundConfigLayoutMobile]:
      'Mobile Ansicht: Auswahl der Konfigurations-Unterseite.',
    [InboundConnectorConfigLayoutTestIds.selectConfigSubpage]:
      'Zwischen Verbindung, Abgleich und Operationen wechseln.',
  },
}
